import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import forms from 'constants/forms';
import Input from 'components/atoms/input';
import useUser from 'utils/useUser';
import { isAdmin } from 'utils/userTypeHelper';

const Contact = ({ errors }) => {
  const { userType } = useUser();
  const iamAdmin = isAdmin(userType);

  const contact = [...forms.adminPanelsClinic.clinicEdit.contact];
  const agencies = useSelector((state) => state.adminPanelClinics.agencies);
  let options = [];
  if (iamAdmin)
    options = useMemo(() =>
      agencies
        ? agencies.map(({ guid, legalname }) => ({
            value: guid,
            label: legalname,
          }))
        : [],
    );

  return (
    <div className="admin-patient-form-block">
      <span>Contact</span>
      <Row>
        {iamAdmin && (
          <Col lg="6" md="6" sm="6" xs="12">
            <Input
              label="Agency"
              id="agencyGuid"
              type="select"
              options={options}
              onChange={(e, setFieldValue) =>
                setFieldValue('agencyGuid', e.value)
              }
              disabled={false}
            />
            {errors.agencyGuid ? (
              <div className="input-error">{errors.agencyGuid}</div>
            ) : null}
          </Col>
        )}
        {contact.map((field) => (
          <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
            <Input {...field} disabled={false} />
            {errors[field.id] ? (
              <div className="input-error">
                {errors[field.id].split('.')[0]}
              </div>
            ) : null}
          </Col>
        ))}
      </Row>
    </div>
  );
};

Contact.propTypes = {
  errors: PropTypes.shape({
    agencyGuid: PropTypes.string,
  }).isRequired,
};

export default Contact;
